import React from "react";

type Props = {
  checked?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};
const ToggleButton = (props: Props) => {
  return (
    <label className="flex cursor-pointer select-none items-center">
      <div className="relative">
        <input
          type="checkbox"
          defaultChecked={props.checked}
          onChange={props.onChange}
          className="sr-only"
        />
        <div
          className={`box block h-7 w-12  rounded-full ${
            props.checked ? "bg-[#65C466]" : "bg-[#E9E9EA]"
          }`}
        ></div>
        <div
          className={`absolute left-0.5 top-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-white transition ${
            props.checked ? "translate-x-5" : ""
          }`}
        ></div>
      </div>
    </label>
  );
};

export default ToggleButton;
